import { IconSizeType } from '@prophecy/icons';
import { theme } from '@prophecy/theme';

import { Stack } from '../Layout';
import { HintPropsType } from '../Misc/Hint';
import { useHint } from './Hint';
import { Text } from './Text';
import { TextProps } from './types';
export interface LabelWithHintProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  level?: TextProps['level'];
  tone?: string;
  weight?: string;
  hint?: HintPropsType;
}

export const levelToIconSizeMap: { [key: string]: IconSizeType } = {
  // Todo: will be replaced with new tokens
  xs: 'xxs',
  sm13: 'xxs',
  sm: 'xs',
  xl: 'xs'
};

export const LabelWithHint = ({
  children,
  hint,
  level = 'sm',
  tone = theme.colors.gray500,
  ...restProps
}: LabelWithHintProps) => {
  const _hint = useHint({ hint, level, tone });

  return (
    <Text level={level} {...restProps}>
      <Stack direction='horizontal' gap={theme.spaces.x8} alignY='center'>
        {children}
        {_hint}
      </Stack>
    </Text>
  );
};
